// store/modules/filters/networkNetworksFilter.js

const state = {
    filterBlock: {},
    selectedFilter: { text: 'Active', value: 1 },
    countNets: 50,
    selectedTab: 'All',
    chosenPage: 1,
};

const mutations = {
    setSelectedFilter(state, filter) {
        state.selectedFilter = filter;
    },
    setCountNets(state, countNets) {
        state.countNets = countNets;
    },
    setSelectedTab(state, tab) {
        state.selectedTab = tab;
    },
    setFilterBlock(state, filter) {
        state.filterBlock = filter;
    },
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },
};

const actions = {
    updateSelectedFilter({ commit }, filter) {
        commit('setSelectedFilter', filter);
    },
    updateCountNets({ commit }, countNets) {
        commit('setCountNets', countNets);
    },
    updateSelectedTab({ commit }, tab) {
        commit('setSelectedTab', tab);
    },
    updateFilterBlock({ commit }, filter) {
        commit
            ('setFilterBlock', filter);
    },
    updateChosenPage({ commit }, chosenPage) {
        commit('setChosenPage', chosenPage);
    },
};

const getters = {
    getFilterBlock: (state) => state.filterBlock,
    getSelectedFilter: (state) => state.selectedFilter,
    getCountNets: (state) => state.countNets,
    getSelectedTab: (state) => state.selectedTab,
    getChosenPage: (state) => state.chosenPage,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};